
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitosataracab() {



    const cardData =
    {
        keyword: ' Mumbai to Satara  Cab   ',
        heading: 'Deva Cabs: Mumbai to Satara  Cab    ',
        headingDescription: 'Deva Cabs offers dependable and comfortable cab services from Mumbai to Satara, perfect for family trips, business travel, and weekend escapes. Covering a distance of roughly 250 km, our well-maintained vehicles—Sedans, SUVs, and Innova Crysta—ensure a smooth and scenic ride through the Western Ghats and Konkan plains. Enjoy the convenience of experienced drivers, fixed-fare packages, and door-to-door pickup. With 24/7 availability, transparent pricing, and top-tier customer care, Deva Cabs makes your Mumbai to Satara cab journey safe, efficient, and stress-free.',

        top: 'Top Places to Visit in Satara with Deva Cabs',

"topPlaces": [
  {
    "title": "Kaas Plateau",
    "location": "Satara, Maharashtra",
    "description": "A UNESCO World Natural Heritage Site, Kaas Plateau (Kaas Pathar) blooms into a spectacular ‘Valley of Flowers’ during the monsoon (Aug–Oct), with over 850 species of wildflowers, orchids, and endemic plants—an unmatched botanic spectacle." 
  },
  {
    "title": "Thoseghar Waterfalls",
    "location": "Thoseghar, Satara District, Maharashtra",
    "description": "A series of rugged, multi-tiered waterfalls plunging up to 200 m amid dense forests, Thoseghar Falls are especially dramatic during the monsoon and popular for picnics and bird-spotting." 
  },
  {
    "title": "Sajjangad Fort",
    "location": "Satara, Maharashtra",
    "description": "An easy-to-access hill fort and pilgrimage site, Sajjangad is the Samadhi of Sant Ramdas Swami. Known as the 'Fort of the Good', it offers spiritual atmosphere, regular bhajans, and panoramic views." 
  },
  {
    "title": "Ajinkyatara Fort",
    "location": "Satara, Maharashtra",
    "description": "Perched atop one of the seven hill peaks at 3,300 ft, this Maratha-era fort offers historic ruins, temples, and commanding views of Satara city—perfect for trekkers and history buffs." 
  },
  {
    "title": "Pratapgad Fort",
    "location": "Near Mahabaleshwar, Satara District, Maharashtra",
    "description": "Built in 1656 by Shivaji, this historic fort commemorates the battle where he killed Afzal Khan. It features sturdy walls, temples, and excellent vantage points over the Konkan ghats." 
  },
  {
    "title": "Vajrai (Bhimbloli) Waterfall",
    "location": "Bhambavli, Satara District, Maharashtra",
    "description": "Also called Vajrai Falls, this massive three-tiered waterfall plunges around 260 m and is one of India’s highest waterfalls—especially powerful and photogenic during the rainy season." 
  },
  {
    "title": "Sangam Mahuli & Kshetra Mahuli",
    "location": "Satara, Maharashtra",
    "description": "A sacred and scenic confluence point of rivers Krishna and Venna, bordered by ancient temples—ideal for spiritual seekers, picnics, and riverside rituals." 
  },
  {
    "title": "Shri Chhatrapati Shivaji Maharaj Museum",
    "location": "Satara, Maharashtra",
    "description": "Dedicated to the Maratha heritage, this museum showcases Shivaji-era weapons, armour, and historical artifacts—great for history enthusiasts." 
  },
  {
    "title": "Koyna Dam & Shivsagar Lake",
    "location": "Koyna, Satara District, Maharashtra",
    "description": "One of India’s largest earth dams, surrounded by the Shivsagar reservoir. Visitors enjoy boating, lakeside views, and proximity to the Koyna Wildlife Sanctuary." 
  },
  {
    "title": "Mayani Bird Sanctuary",
    "location": "Mayani, Satara District, Maharashtra",
    "description": "Built around a large man-made lake, this sanctuary is famed for waterbirds and peacocks—especially active and photogenic in the monsoons." 
  }
],



 "services": [
    {
      "name": "Mumbai to Satara Cab",
      "description": "Book a comfortable cab from Mumbai to Satara with our reliable long-distance travel service. Whether you’re planning a solo trip, family visit, or business journey, we provide clean, AC vehicles with professional chauffeurs. Choose from economy, SUV, or premium models based on your preference. Enjoy door-to-door pickup, on-time service, and affordable pricing for a hassle-free journey."
    },
    {
      "name": "Mumbai to Karad Taxi",
      "description": "Travel with ease from Mumbai to Karad with our taxi service offering one-way or round trip options. Our vehicles come equipped with air conditioning, comfortable seating, and trained drivers who ensure your safety and comfort. Perfect for corporate travel, personal visits, or family outings, this service guarantees a smooth and relaxing ride."
    },
    {
      "name": "Mumbai to Sangli Cab",
      "description": "Get dependable cab service from Mumbai to Sangli with our professional travel solutions. Our fleet includes sedans, SUVs, and luxury vehicles to suit different travel needs. Enjoy spacious seating, courteous drivers, and seamless travel for business, tourism, or personal purposes. We offer both one-way and return trip packages with flexible timing."
    },
    {
      "name": "Book cab Mumbai to Satara Karad Sangli",
      "description": "Planning to visit Satara, Karad, or Sangli from Mumbai? Book a single cab to cover all three destinations in one go. Our multi-city cab package provides convenience, affordability, and flexibility. Ideal for long trips, family visits, or regional travel, all vehicles are AC and driven by experienced chauffeurs for a safe and smooth ride."
    },
    {
      "name": "Round trip Satara Karad Sangli cab from Mumbai",
      "description": "Make your round trip from Mumbai to Satara, Karad, or Sangli comfortable and affordable with our specially designed travel packages. We offer reliable vehicles, round-the-clock service, and fixed pricing for round trips. Book in advance and travel with peace of mind, knowing your return journey is already planned."
    },
    {
      "name": "Chauffeur cab Mumbai to Sangli",
      "description": "Enjoy a premium experience with our chauffeur-driven cab service from Mumbai to Sangli. Our well-trained drivers ensure a professional and smooth ride while you relax or work on the go. Ideal for business travelers and families alike, this service combines comfort, safety, and convenience."
    },
    {
      "name": "SUV cab hire Mumbai to Karad",
      "description": "Need more space and comfort? Hire an SUV cab from Mumbai to Karad and enjoy a spacious, smooth ride—perfect for families or small groups. Our SUVs are equipped with AC, ample luggage space, and reclining seats, ensuring a pleasant journey even over longer distances."
    },
    {
      "name": "Affordable cab hire Mumbai to Satara",
      "description": "Travel economically without compromising on quality. Our affordable cab hire from Mumbai to Satara offers value-for-money transportation with neat vehicles, courteous drivers, and no hidden charges. Ideal for students, solo travelers, or budget-conscious families."
    },
    {
      "name": "AC cab Mumbai to Sangli",
      "description": "Beat the heat and travel comfortably in an AC cab from Mumbai to Sangli. Our air-conditioned cars are regularly sanitized and serviced for your safety and comfort. Choose from various vehicle categories and enjoy a relaxing long-distance trip with our expert drivers."
    }
  ],
  "tableData": [
    ["Mumbai to Satara Cab", "-Mumbai to Karad Taxi"],
    ["Mumbai to Sangli Cab", "-Book cab Mumbai to Satara Karad Sangli"],
    ["Round trip Satara Karad Sangli cab from Mumbai", "-Chauffeur cab Mumbai to Sangli"],
    ["SUV cab hire Mumbai to Karad", "-Affordable cab hire Mumbai to Satara"],
    ["AC cab Mumbai to Sangli", ""]
  ],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Satara Cab Service",
    "WhyChoosedescription": "Travel comfortably and reliably from Mumbai to Satara with our dedicated cab service. Whether for business, family visits, or leisure trips, we ensure timely pickups and smooth journeys over the approximately 280 km route. Our professional drivers and well-maintained vehicles make your travel stress-free and enjoyable."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Medium-Distance Travel",
    "WhyChoosedescription": "Our fleet includes air-conditioned cars and SUVs that offer ample legroom and luggage space, ensuring a relaxing ride for solo travelers, families, or groups. Equipped with modern amenities and ergonomic seating, your journey to Satara will be pleasant and comfortable."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Satara Route",
    "WhyChoosedescription": "Our drivers are highly experienced and knowledgeable about the best routes and traffic conditions between Mumbai and Satara. They prioritize safety, punctuality, and passenger comfort, ensuring a smooth and timely journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We provide upfront pricing inclusive of tolls, fuel, and driver allowances, with no hidden fees. Our competitive rates help you plan your budget confidently, making our Mumbai to Satara cab service affordable and reliable."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Our cabs are available around the clock to match your preferred travel times. Whether you want an early morning or late-night departure, we offer the flexibility to fit your schedule."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Satara cab is quick and convenient via our website or customer support. Receive instant confirmation along with fare and driver details to plan your trip confidently."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "Safety is our priority. All vehicles are regularly maintained and sanitized before each trip. Equipped with seat belts, GPS tracking, and emergency kits, our cabs ensure a secure and comfortable journey."
  },
  {
    "WhyChooseheading": "Customizable Travel Packages",
    "WhyChoosedescription": "We offer flexible travel options including one-way trips, round trips, and multi-day plans with stops along the route. Our services can be tailored to suit your specific travel needs for the Mumbai to Satara journey."
  }
]







    }




const faqData = [
  {
    question: "Can I book a cab from Mumbai to Satara with Deva Cabs?",
    answer: "Yes, Deva Cabs provides reliable and comfortable cab services from Mumbai to Satara for personal, family, and business travel."
  },
  {
    question: "How long does the journey from Mumbai to Satara take by cab?",
    answer: "The journey typically takes around 5 to 6 hours depending on traffic and route."
  },
  {
    question: "What vehicle options are available for the Mumbai to Satara trip?",
    answer: "We offer a variety of vehicles including sedans, SUVs, Innova Crysta, Ertiga, and tempo travellers based on your group size and comfort."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Satara?",
    answer: "Yes, you can book both one-way and round-trip cabs for Mumbai to Satara with Deva Cabs."
  },
  {
    question: "Are tolls and driver allowances included in the fare?",
    answer: "Toll charges and driver allowances are usually extra and will be shared clearly during booking."
  },
  {
    question: "Is the cab service from Mumbai to Satara available at night?",
    answer: "Yes, our services are available 24/7, so you can book a cab to Satara at any time."
  },
  {
    question: "Is it safe to travel with Deva Cabs from Mumbai to Satara?",
    answer: "Yes, safety is our top priority. Our drivers are experienced, background-verified, and trained for long-distance routes."
  },
  {
    question: "Can I request stops or sightseeing on the way to Satara?",
    answer: "Yes, you can customize your trip with planned halts or sightseeing points as per your requirement."
  },
  {
    question: "Is this service ideal for families and senior citizens?",
    answer: "Absolutely. Our clean, comfortable, and spacious vehicles are ideal for all age groups including senior citizens."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Satara travel?",
    answer: "Deva Cabs ensures reliable service, punctual pickups, professional drivers, and transparent pricing for a hassle-free trip."
  }
];

const testimonialData = [
  {
    id: 65,
    name: 'Mr. Ramesh Gokhale',
    role: 'Senior Citizen',
    review: 'The Mumbai to Satara cab by Deva Cabs was very comfortable. The driver was courteous and punctual.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 66,
    name: 'Ms. Neha Patil',
    role: 'Family Traveler',
    review: 'Our family trip from Mumbai to Satara was great thanks to Deva Cabs. The vehicle was clean and spacious.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Satara, Karad & Sangli Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-satara-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Satara, Karad, and Sangli cabs online with Deva Cabs. One-way and round-trip taxi services available with AC, SUV, chauffeur-driven, and affordable cab options.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "396"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7300",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-satara-cab" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Satara, Karad & Sangli Cab | Book Taxi Online | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Satara, Karad, and Sangli cab online with Deva Cabs. Affordable round-trip and one-way taxi options including AC, SUV, and chauffeur-driven vehicles for a comfortable ride." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Satara Cab, Mumbai to Karad Taxi, Mumbai to Sangli Cab, Book cab Mumbai to Satara Karad Sangli, Round trip Satara Karad Sangli cab from Mumbai, Chauffeur cab Mumbai to Sangli, SUV cab hire Mumbai to Karad, Affordable cab hire Mumbai to Satara, AC cab Mumbai to Sangli" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/42.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitosataracab;